import type { FC } from 'react';

interface PromptPreviewProps {
  template?: string | null;
  placeholderKey: string;
  replacement: string;
  className?: string;
}

export function renderPromptTemplate(
  template: string | null | undefined,
  placeholderKey: string,
  replacement?: string | null
): string {
  const tpl = template ?? '';
  const replacementText = replacement ?? '';

  try {
    const escKey = placeholderKey.replace(/[.*+?^${}()|[\\]\\]/g, '\\$&');
    const reHandlebars = new RegExp(`{{\\s*${escKey}\\s*}}`, 'g');
    const rePlain = new RegExp(`\\b${escKey}\\b`, 'g');
    return tpl
      .replace(reHandlebars, replacementText)
      .replace(rePlain, replacementText);
  } catch (e) {
    // On error, return original template so UI still shows something meaningful
    return tpl;
  }
}

export const PromptPreview: FC<PromptPreviewProps> = ({
  template,
  placeholderKey,
  replacement,
  className = '',
}) => {
  const rendered = renderPromptTemplate(template, placeholderKey, replacement);

  return (
    <div
      className={`mt-2 rounded-md border border-border p-3 bg-muted ${className}`}
    >
      <div className='text-xs underline font-medium'>Preview</div>
      <pre className='whitespace-pre-wrap text-[10px]'>{rendered}</pre>
    </div>
  );
};

export default PromptPreview;
